import { ColumnItem, ColumnComponent } from '../MultiColumn.models'
import {  ComponentContainer, Heading, SubHeading } from './Column.style'
import { DynamicComponent } from '../DynamicComponent/DynamicComponent'

export const Column = ({ heading, subHeading, components }: ColumnItem) => {

  return (
    <ComponentContainer> 
        {heading &&
          <Heading>{heading}</Heading>
        }
        {subHeading &&
          <SubHeading>{subHeading}</SubHeading>
        }
        {components && components.map((component: ColumnComponent) => {
          return <DynamicComponent key={component.type} {...component} hasImageOnly={components.length === 1 && !heading && !subHeading}/>
        })}
    </ComponentContainer>
  )
}
